import getRouteTransferType from "@Route/features/transportType/functions/getRouteTransferType";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";
import useQuantityAwareTranslation from "@Translation/hooks/useQuantityAwareTranslation";

/*
* This hook is used to get the translation key for a transport type by its ID
* @param {string} id - the ID of the transport type
* @return {string} - the translation key for the transport type
 */
export const useTransportTypeById = (id: string) => {
    return `sys.${getRouteTransferType(parseInt(id, 10) as RouteTransferTypeKeys)}`
}